<section class="member-recipients-wrapper">
  <div class="member-recipients-header">
    <span class="title">Recipient List</span>
    <div class="filter-container">
      <mat-form-field appearance="outline" class="filter-input">
        <mat-icon matPrefix>search</mat-icon>
        <input
          (input)="onFilterChanged($event)"
          matInput
          placeholder="Search..."
        />
      </mat-form-field>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="member-recipients-content">
    @for (member of dataSource(); track member) {
    <div class="list">
      <div class="parent-row">
        <mat-icon (click)="toggleExpand(member)">{{
          member.expanded ? 'expand_more' : 'chevron_right'
        }}</mat-icon>
        <mat-checkbox
          class="shared-recipient-contact-checkbox"
          color="primary"
          [checked]="member.selected"
          [indeterminate]="member.indeterminate"
          (change)="toggleMember(member, $event.checked)"
        >
          {{ member.name }}
        </mat-checkbox>
      </div>
      @if (member.expanded) {
      <div class="children">
        @for (contact of member.contacts; track contact) {
        <div class="child-row">
          <mat-checkbox
            color="primary"
            class="shared-recipient-contact-checkbox"
            [checked]="contact.selected"
            (change)="toggleContact(member, contact, $event.checked)"
          >
            {{ contact.name }}
          </mat-checkbox>
        </div>
        }
      </div>
      }
    </div>
    } @if (!dataSource().length) {
    <div class="no-matches">No matches.</div>
    }
  </div>
</section>
